/* Enhancements around native Xtra and the existing AddToQuote app. */
(() => {
  const header = document.querySelector('#header');
  const sizeHeader = () => document.documentElement.style.setProperty('--ufi-header-height', `${Math.min(header?.getBoundingClientRect().height || 100,180)}px`);
  sizeHeader(); if(header && window.ResizeObserver) new ResizeObserver(sizeHeader).observe(header);
  const quoteSelectors = '.sc-raq-add-to-quote-btn-hldr,.sc-raq-add-to-quote-btn,.sc-raq-floating-cart,.sc-raq-btn,[data-add-quote],a[href*="/pages/sc-raq-quote-list"],[id*="sc-raq"],[class*="sc-raq-"],[id*="sc_raq"],[id*="youquote" i],[class*="youquote" i],iframe[src*="youquote" i]';
  if (window.ufiCustomerLoggedIn) {
    const removeGuestControls = () => document.querySelectorAll(quoteSelectors).forEach(el => el.remove());
    removeGuestControls();
    new MutationObserver(removeGuestControls).observe(document.body,{childList:true,subtree:true});
    document.addEventListener('click',event => {if(event.target.closest(quoteSelectors)){event.preventDefault();event.stopImmediatePropagation();}},true);
  } else {
    const updateCount = () => {
      const app=window.sc_raq_app_global;
      if(!app || typeof app.get_added_item_list !== 'function') return;
      try { const list=app.get_added_item_list(); if(!Array.isArray(list)) return;
        const count=list.reduce((n,item)=>n+Math.max(0,Number(item.qty)||0),0);
        document.querySelectorAll('[data-ufi-quote-count]').forEach(el=>{el.textContent=String(count);el.hidden=false;});
      } catch (_) { /* Native app remains usable if its list is not ready. */ }
    };
    document.addEventListener('ufi:quote-updated',updateCount);window.addEventListener('storage',updateCount);window.addEventListener('focus',updateCount);
    let attempts=0;const ready=setInterval(()=>{updateCount();if(++attempts>=20||window.sc_raq_app_global)clearInterval(ready)},500);
  }
  function categoryToggles(scope = document) {
    scope.querySelectorAll('.ufi-shop-menu').forEach(menu => {
      const mobile = Boolean(menu.closest('.ufi-mobile-shop'));
      const links = [...menu.querySelectorAll('[data-ufi-category]')];
      const panels = [...menu.querySelectorAll('[data-ufi-category-panel]')];
      const overview = menu.querySelector('[data-ufi-category-overview]');
      let lastButton;
      function reset() {
        if (!mobile) return;
        overview.hidden = false;
        panels.forEach(panel => panel.hidden = true);
        links.forEach(link => link.classList.remove('is-active'));
        menu.querySelectorAll('.ufi-category-expand').forEach(button => button.setAttribute('aria-expanded','false'));
      }
      links.forEach(link => {
        if (link.dataset.touchReady) return;
        link.dataset.touchReady = 'true';
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'ufi-category-expand'; button.textContent = '+';
        button.setAttribute('aria-label',`Show ${link.textContent.trim()} subcategories`);
        button.setAttribute('aria-expanded','false');
        button.addEventListener('click',event => {
          event.preventDefault(); event.stopPropagation();
          link.dispatchEvent(new Event('mouseenter'));
          menu.querySelectorAll('.ufi-category-expand').forEach(item => item.setAttribute('aria-expanded',String(item === button)));
          if (mobile) {
            overview.hidden = true;
            panels.forEach(panel => panel.hidden = panel.dataset.ufiCategoryPanel !== link.dataset.ufiCategory);
            lastButton = button;
            const back = panels.find(panel => !panel.hidden)?.querySelector('[data-ufi-category-back]');
            back?.focus({preventScroll:true}); menu.querySelector('.ufi-mega').scrollTop = 0;
          }
        });
        const row = document.createElement('div'); row.className = 'ufi-category-row';
        link.before(row); row.append(link,button);
      });
      if (mobile && !menu.dataset.mobileReady) {
        menu.dataset.mobileReady = 'true';
        menu.querySelectorAll('[data-ufi-category-back]').forEach(button => button.addEventListener('click',() => { reset(); lastButton?.focus({preventScroll:true}); }));
        menu.addEventListener('toggle',() => { if (!menu.open) reset(); });
        reset();
      }
    });
  }
  categoryToggles();document.addEventListener('shopify:section:load',event => categoryToggles(event.target));
})();
